// extracted by mini-css-extract-plugin
module.exports = {"root":"VirtualizedList_root__UPfIa","row":"VirtualizedList_row__MdQsV"};